import authRoles from '../../../../../auth/authRoles';

const { everyoneButGuest } = authRoles;

export default [
    {
        id: 'dashboard',
        title: 'Dashboard',
        icon: 'Home',
        path: '/dashboard',
        roles: everyoneButGuest,
        permission: ['GetDashboardDetails'],
    },
    {
        id: 'transport-hauler-management',
        title: 'Hauler Management',
        icon: 'Hauling',
        path: '/hauler-management',
        roles: ['transport'],
        permission: ['AccessHaulerManagement'],
        subPermissionOnly: true,
    },
    {
        id: 'processor-plant-management',
        title: 'Plant Management',
        icon: 'Processor',
        path: '/plant-management',
        roles: ['processor'],
        permission: ['AccessPlantManagement'],
        subPermissionOnly: true,
    },
    {
        id: 'processor-transport-receiving',
        title: 'Receiving',
        icon: 'Receiving',
        path: '/receiving',
        roles: ['processor', 'transport'],
        permission: ['ViewReceivingDropoffs'],
        subPermissionOnly: true,
    },
    {
        id: 'producer-producer-management',
        title: 'Producer Management',
        icon: 'Producer',
        path: '/producer-management',
        roles: ['producer'],
        permission: ['AccessProducerManagement'],
        subPermissionOnly: true,
    },
    {
        id: 'raw-milk-tracking-group',
        title: 'Raw Milk Tracking',
        icon: 'RawMilk',
        type: 'group',
        subPermissionOnly: true,
        requireAllPermissions: false,
        children: [
            {
                id: 'scheduling-title',
                type: 'subheader',
                title: 'Scheduling',
            },
            {
                id: 'milk-schedule-list-view',
                title: 'Load Schedules',
                icon: 'RawMilk',
                path: '/milk-schedule-list-view',
                roles: ['admin', 'processor', 'transport'],
                permission: ['GetMilkScheduleDetails'],
                subPermissionOnly: true,
            },
            {
                id: 'transportation-title',
                type: 'subheader',
                title: 'Transportation',
            },
            {
                id: 'route-sessions',
                title: 'Route Sessions',
                icon: 'RawMilk',
                path: '/route-sessions',
                roles: ['admin', 'processor'],
                permission: ['ListRouteSessions'],
            },
            {
                id: 'pickups',
                title: 'Pickups',
                icon: 'RawMilk',
                path: '/pickups',
                roles: ['admin', 'transport'],
                permission: ['ListPickups'],
            },
            {
                id: 'dropoffs',
                title: 'Dropoffs',
                icon: 'RawMilk',
                path: '/dropoffs',
                roles: ['admin', 'transport', 'processor'],
                permission: ['ListDropoffs'],
            },
            {
                id: 'route-management',
                title: 'Route Management',
                icon: 'Route',
                path: '/list-schedule-routes',
                roles: ['admin', 'transport'],
                permission: ['ListScheduleRoutes'],
            },
            {
                id: 'transportation-title',
                type: 'subheader',
                title: 'Logistics',
            },
            {
                id: 'manifest',
                title: 'Manifests',
                icon: 'RawMilk',
                path: '/manifest-search',
                roles: ['admin'],
                permission: ['ListManifests'],
                subPermissionOnly: true,
            },
            {
                id: 'driver-location',
                title: 'Driver Location',
                icon: 'RawMilk',
                path: '/driver-locations',
                roles: ['admin', 'transport'],
                permission: ['ViewDriverLocations'],
            },
            {
                id: 'cip-wash',
                title: 'CIP Wash',
                icon: 'RawMilk',
                path: '/washes',
                roles: ['admin'],
                permission: ['ListCIPWash'],
            },
            {
                id: 'transport-cip-wash',
                title: 'CIP Wash',
                icon: 'RawMilk',
                path: '/washes',
                roles: ['transport'],
                permission: ['ListCIPWash'],
                subPermissionOnly: true,
            },
            {
                id: 'closed-period',
                title: 'Close Period',
                path: '/close-period',
                roles: ['admin'],
                permission: ['ManageClosePeriod'],
                subPermissionOnly: true,
            },
        ],
    },
    {
        id: 'quality-group',
        title: 'Quality',
        icon: 'Quality',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'labs-title',
                type: 'subheader',
                title: 'Labs',
            },
            {
                id: 'lab-reports',
                title: 'Lab Reports',
                icon: 'Quality',
                path: '/lab-reports',
                roles: ['admin'],
                permission: ['ListLabReports'],
            },
            {
                id: 'dropoff-samples',
                title: 'Load Samples',
                icon: 'Quality',
                path: '/dropoff-samples',
                roles: ['admin'],
                permission: ['ListLabReports'],
            },
        ],
    },
    {
        id: 'barcode-input',
        title: 'Barcode Input',
        icon: 'Quality',
        roles: ['lab_provider'],
        path: '/barcode-input',
    },
    {
        id: 'lab-reports',
        title: 'Lab Reports',
        icon: 'Quality',
        roles: ['lab_provider'],
        path: '/lab-reports',
    },
    {
        id: 'payroll-group',
        title: 'Payroll',
        icon: 'Invoicing',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'monthly-pay-reports',
                title: 'Producer Payroll',
                icon: 'Payroll',
                path: '/monthly-pay-reports',
                roles: ['admin'],
                permission: ['ManageProducerPayReports'],
            },
            {
                id: 'hauler-pay-reports',
                title: 'Hauler Payroll',
                icon: 'Payroll',
                path: '/hauler-pay-reports',
                roles: ['admin'],
                permission: ['ManageHaulerPayReports'],
            },
            {
                id: 'hauler-pay-reports',
                title: 'Monthly Pay Reports',
                icon: 'Payroll',
                path: '/hauler-pay-reports',
                roles: ['transport'],
                permission: ['ViewHaulerPayReport'],
                subPermissionOnly: true,
            },
            {
                id: 'vendor-pay-reports',
                title: 'Vendor Payroll',
                icon: 'Payroll',
                path: '/vendor-pay-reports',
                roles: ['admin'],
                permission: ['ManageVendorPayReports'],
            },
            {
                id: 'payment-status',
                title: 'Payment Status',
                icon: 'Payroll',
                path: '/payment-status',
                roles: ['admin'],
                permission: ['ManagePaymentStatus'],
            },
            {
                id: 'pay-tools-title',
                type: 'subheader',
                title: 'Pay Tools',
            },
            {
                id: 'payment-line-item-configs',
                title: 'MooRules',
                icon: 'Payroll',
                path: '/moo-rules',
                roles: ['admin'],
                permission: ['ManageMooRules'],
            },
            {
                id: 'price-management',
                title: 'Price Management',
                roles: ['admin'],
                path: '/price-management/raw-milk',
                permission: ['ViewPricing'],
            },
            {
                id: 'assignees',
                title: 'Assignees',
                icon: 'Payroll',
                path: '/assignees',
                roles: ['admin'],
                permission: ['ManageAssignees'],
            },
            {
                id: 'deferrals',
                title: 'Deferrals',
                icon: 'Payroll',
                path: '/deferrals',
                roles: ['admin'],
                permission: ['ManageDeferrals'],
            },
            {
                id: 'split-producers',
                title: 'Split Producers',
                icon: 'Payroll',
                path: '/split-producers',
                roles: ['admin'],
                permission: ['ManageSplitProducers'],
            },
        ],
    },
    {
        id: 'pooling-group',
        title: 'Pooling',
        icon: 'Pooling',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'pooling-decisions',
                title: 'Pooling Decisions',
                icon: 'Pooling',
                path: '/pooling-decisions',
                roles: ['admin'],
                permission: ['ManagePoolingDecisions'],
            },
            {
                id: 'processor-totals',
                title: 'Processor Totals',
                icon: 'Pooling',
                path: '/processor-fmmo-monthly-totals',
                roles: ['admin'],
                permission: ['ManageProcessorTotals'],
            },
            {
                id: 'producer-touchbase',
                title: 'Producer Touchbase',
                icon: 'Pooling',
                path: '/producer-touch-base',
                roles: ['admin'],
                permission: ['ManageProducerTouchBases'],
            },
        ],
    },
    {
        id: 'memberships-group',
        title: 'Memberships',
        icon: 'Memberships',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'communication-title',
                type: 'subheader',
                title: 'Communication',
            },
            {
                id: 'member-center',
                title: 'Member Center',
                icon: 'Memberships',
                path: '/member-center',
                roles: ['admin'],
                permission: ['ViewMemberCenter'],
                subPermissionOnly: true,
            },
            {
                id: 'file-share-received',
                title: 'Received Files',
                icon: 'Files',
                path: '/shared-files/received',
                roles: everyoneButGuest.filter((role) => !['producer', 'processor'].includes(role)),
                permission: ['ListSharedFiles'],
            },
            {
                id: 'file-share-shared',
                title: 'Shared Files',
                icon: 'Files',
                path: '/shared-files/shared',
                roles: ['admin', 'producer_business'],
                permission: ['ListSharedFiles'],
            },
            {
                id: 'documents',
                title: 'Documents',
                icon: 'Files',
                path: '/documentation/tables',
                roles: ['admin'],
                permission: ['ViewDocumentation'],
            },
            {
                id: 'communication-title',
                type: 'subheader',
                title: 'Equity',
            },
            {
                id: 'equity-membership',
                title: 'Memberships',
                icon: 'Memberships',
                path: '/equity/membership',
                roles: ['admin'],
                permission: ['ManageEquity'],
            },
            {
                id: 'equity-statements',
                title: 'Statements',
                icon: 'Memberships',
                path: '/equity/statements',
                roles: ['admin'],
                permission: ['ManageEquity'],
            },
        ],
    },
    {
        id: 'reports-group',
        title: 'Reports',
        icon: 'Reports',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'embedded-reports',
                title: 'Reporting',
                icon: 'Reports',
                path: '/reporting',
                roles: ['admin', 'transport', 'processor', 'lab-provider'],
            },
            {
                id: 'upload-download',
                title: 'Upload/Download',
                icon: 'Files',
                path: '/upload-download',
                roles: ['admin', 'transport', 'processor'],
                permission: ['UploadDownload'],
            },
        ],
    },
    {
        id: 'moo-intel-group',
        title: 'MooIntel',
        icon: 'MooIntel',
        type: 'group',
        requireAllPermissions: false,
        badge: {
            title: 'NEW',
            bg: '#00A2F5',
            fg: '#fefefeff',
        },
        children: [
            {
                id: 'raw-milk-prediction-report',
                title: 'Milk Prediction',
                path: '/milk-prediction-report',
                roles: ['admin'],
                permission: ['ViewMilkPredictionReport'],
                badge: {
                    title: 'BETA',
                    bg: '#9300F5',
                    fg: '#fefefeff',
                },
            },
            {
                id: 'contract-performance-report',
                title: 'Contract Performance',
                path: '/contract-performance-report',
                roles: ['admin'],
                permission: ['ViewContractPerformanceReport'],
                badge: {
                    title: 'BETA',
                    bg: '#9300F5',
                    fg: '#fefefeff',
                },
            },
            {
                id: 'supply-outlook-report',
                title: 'Supply Outlook',
                path: '/supply-outlook-report',
                roles: ['admin'],
                permission: ['ViewSupplyOutlookReport'],
                badge: {
                    title: 'BETA',
                    bg: '#9300F5',
                    fg: '#fefefeff',
                },
            },
        ],
    },
    {
        id: 'producer-pickups',
        title: 'Pickups',
        icon: 'RawMilk',
        path: '/pickups',
        roles: ['producer'],
        permission: ['ListPickups'],
    },
    {
        id: 'producer-pickups-labs',
        title: 'Pickups & Labs',
        icon: 'Quality',
        path: '/pickups-and-labs',
        roles: ['producer'],
        permission: ['ListPickupsAndLabs'],
    },
    {
        id: 'producer-lab-reports',
        title: 'Lab',
        icon: 'Quality',
        path: '/lab-reports',
        roles: ['producer'],
        permission: ['ListLabReports'],
    },
    {
        id: 'producer-penalty',
        title: 'Penalty Status',
        icon: 'Quality',
        roles: ['producer'],
        path: '/penalty-status',
        permission: ['ListBactoAlert'],
    },
    {
        id: 'producer-monthly-pay-reports',
        title: 'Monthly Pay Reports',
        icon: 'Finance',
        path: '/monthly-pay-reports',
        roles: ['producer'],
        permission: ['ListMonthlyReports'],
    },
    {
        id: 'producer-reports',
        title: 'Reporting',
        icon: 'Reports',
        path: '/reporting',
        roles: ['producer'],
    },
    {
        id: 'producer-files',
        title: 'Files',
        icon: 'Files',
        path: '/shared-files/received',
        roles: ['producer', 'processor'],
        permission: ['ListSharedFiles'],
    },
    {
        id: 'producer-upload-download',
        title: 'Upload/Download',
        icon: 'Files',
        path: '/upload-download',
        roles: ['producer'],
        permission: ['UploadDownload'],
    },
    {
        id: 'producer-member-center',
        title: 'Member Center',
        icon: 'Memberships',
        path: '/member-center',
        roles: ['producer'],
        permission: ['ViewMemberCenter'],
        subPermissionOnly: true,
    },
    {
        id: 'divider-1',
        type: 'divider',
    },
    {
        id: 'producer-sub-users',
        title: 'Sub-Users',
        icon: 'UsersAndAssets',
        path: '/manage/sub-users',
        roles: ['producer'],
        permission: ['ListSubProducers'],
    },
    {
        id: 'users-and-assets-group',
        title: 'Users and Assets',
        icon: 'UsersAndAssets',
        type: 'group',
        requireAllPermissions: false,
        children: [
            {
                id: 'users-title',
                type: 'subheader',
                title: 'Users',
            },
            {
                id: 'admins',
                title: 'Admins',
                icon: 'Admin',
                path: '/list-admins',
                roles: ['admin'],
                permission: ['ListAdmins'],
            },
            {
                id: 'producers',
                title: 'Producers',
                icon: 'Producer',
                path: '/list-producers',
                roles: ['admin'],
                permission: ['AccessProducerManagement', 'ListProducers'],
                requireAllPermissions: false,
            },
            {
                id: 'processors',
                title: 'Processors',
                icon: 'Processor',
                path: '/list-processors',
                roles: ['admin'],
                permission: ['AccessPlantManagement', 'ListProcessors'],
                requireAllPermissions: false,
            },
            {
                id: 'hauling-companies',
                title: 'Hauling Companies',
                icon: 'Hauling',
                path: '/list-hauling-companies',
                roles: ['admin'],
                permission: ['ListHaulingCompanies', 'AccessHaulerManagement'],
                requireAllPermissions: false,
            },
            {
                id: 'drivers',
                title: 'Drivers',
                icon: 'Driver',
                path: '/list-drivers',
                roles: ['admin', 'transport'],
                permission: ['ListDrivers'],
            },
            {
                id: 'lab-providers',
                title: 'Lab Providers',
                icon: 'Quality',
                path: '/list-lab-providers',
                roles: ['admin'],
            },
            {
                id: 'receivers',
                title: 'Receivers',
                icon: 'SubProcessor',
                path: '/list-receivers',
                roles: ['admin'],
            },
            {
                id: 'processor-receivers',
                title: 'Receivers',
                icon: 'SubProcessor',
                path: '/list-receivers',
                roles: ['processors', 'sub-processors'],
                permission: ['ListReceivers'],
                subPermissionOnly: true,
            },
            {
                id: 'usergroup',
                title: 'User Groups',
                icon: 'UsersAndAssets',
                path: '/user-groups',
                roles: ['admin'],
                permission: ['ListUserGroups'],
                subPermissionOnly: true,
            },
            {
                id: 'other-users-title',
                type: 'subheader',
                title: 'Other Users',
            },
            {
                id: 'sub-users',
                title: 'Sub-Users',
                icon: 'UsersAndAssets',
                path: '/manage/sub-users',
                roles: ['admin', 'processor', 'transport'],
                permission: ['ListSubAdmins', 'ListSubProducers', 'ListSubProcessors', 'ListSubHauling'],
                requireAllPermissions: false,
            },
            {
                id: 'linked-users',
                title: 'Linked Users',
                icon: 'UsersAndAssets',
                path: '/manage/link-users',
                roles: ['admin'],
                permission: ['UpdateMultisiteAccess'],
            },
            {
                id: 'producer-businesses',
                title: 'Producer Businesses',
                icon: 'ProducerBusiness',
                path: '/list-producer-businesses',
                roles: ['admin'],
            },
            {
                id: 'assets-title',
                type: 'subheader',
                title: 'Assets',
            },
            {
                id: 'trailers',
                title: 'Trailers',
                icon: 'Trailer',
                path: '/list-trailers',
                roles: ['admin'],
                permission: ['ListTrailers'],
            },
            {
                id: 'transport-trailers',
                title: 'Trailers',
                icon: 'Trailer',
                path: '/list-trailers',
                roles: ['transport'],
                permission: ['ListTrailers'],
                subPermissionOnly: true,
            },
            {
                id: 'wash-facilities',
                title: 'Wash Facilities',
                icon: 'Processor',
                path: '/wash-facilities',
                roles: ['admin'],
                permission: ['ListCIPWash'],
            },
            {
                id: 'silos',
                title: 'Silos',
                icon: 'Silo',
                path: '/list-silos',
                roles: ['admin', 'processor'],
                permission: ['ListSilos'],
                subPermissionOnly: true,
            },
            {
                id: 'other-title',
                type: 'subheader',
                title: 'Other',
            },
            {
                id: 'session-recording',
                title: 'Session Recording',
                icon: 'UsersAndAssets',
                path: '/session-recording',
                roles: ['admin'],
                permission: ['IsSuperUser'],
            },
        ],
    },
    {
        id: 'logout',
        title: 'Logout',
        icon: 'Logout',
        path: '/logout',
    },
];
